import { render, staticRenderFns } from "./resetPasswordComplete.vue?vue&type=template&id=6117075f&"
import script from "./resetPasswordComplete.vue?vue&type=script&lang=ts&"
export * from "./resetPasswordComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports